// @ts-nocheck
import { FC } from "react";

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { BillToModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";
import AddressInfoDisplay, { AddressInfoDisplayStyles } from "@insite/content-library/Components/AddressInfoDisplay";
import { GridItemProps } from "@insite/mobius/GridItem";
import { Typography } from "@insite/mobius/index";
import { TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Link from "@store/MobiusOverrides/Link/Link";
import useChangeCustomerWithRedirect from "@store/Framework/Common/Hooks/useChangeCustomerAndRedirect";
import FadeIn from "@store/Library/Components/Reporting/Common/FadeIn";
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
import { getMediaQuery } from "@toolkit/Framework/Common/Utilities/mediaQueries";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React from "react";
import { css } from "styled-components";

export interface ManagePoCustomerDisplayStyles {
    columnWrapper?: InjectableCss;
    addressTitleText?: TypographyProps;
    addressGridItem?: GridItemProps;
    addressStyles?: AddressInfoDisplayStyles;
    internalRow?: InjectableCss;
}

const mobileQuery = getMediaQuery({ option: "down", first: true, min: 0, max: 700, last: false });

export const managePoCustomerDisplayStyles: ManagePoCustomerDisplayStyles = {
    addressGridItem: {
        css: css`
            padding: 0;
        `,
        width: [12, 12, 7, 7, 7],
    },
    internalRow: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
            ${mobileQuery} {
                width: 100%;
                align-items: center;
            }
        `,
    },
    columnWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            ${mobileQuery} {
                align-items: center;
                justify-content: center;
                border: 1px solid ${getColor("common.borderDark")};
                padding: 2rem 1.25rem;
                border-radius: 0.75rem;
            }
        `,
    },
    addressTitleText: {
        variant: "h5",
        css: css`
            width: 100%;
            ${mobileQuery} {
                margin-top: 0;
                font-size: ${pxToRem(18)};
                text-align: center;
            }
        `,
        as: "h5",
    },
};

interface ManagePoCustomerDisplayProps {
    customer: BillToModel | ShipToModel;
    label: string;
    linkLabel: string;
    testSelector?: string;
    extendedStyles?: ManagePoCustomerDisplayStyles;
    overrideStyles?: ManagePoCustomerDisplayStyles;
}

const ManagePoCustomerDisplay: FC<ManagePoCustomerDisplayProps> = ({
    customer,
    linkLabel,
    extendedStyles,
    overrideStyles,
    label,
    testSelector = "Customer_Display_Section",
}) => {
    const styles = useExpandProps(managePoCustomerDisplayStyles, extendedStyles, overrideStyles);
    const navigateToChangeCustomerPageWithRedirect = useChangeCustomerWithRedirect();
    return (
        <StyledWrapper {...styles.columnWrapper}>
            <FadeIn appear duration={250} delay={0} animate>
                <Typography {...styles.addressTitleText} data-test-selector={testSelector}>
                    {label}
                </Typography>
                <StyledWrapper {...styles.internalRow}>
                    <AddressInfoDisplay
                        companyName={customer.companyName}
                        address1={customer.address1}
                        city={customer.city}
                        postalCode={customer.postalCode}
                        country={customer.country?.name}
                        extendedStyles={styles.addressStyles}
                    />
                    <Link href={navigateToChangeCustomerPageWithRedirect.linkUrl}>{linkLabel} </Link>
                </StyledWrapper>
            </FadeIn>
        </StyledWrapper>
    );
};

export default ManagePoCustomerDisplay;
